import { createRouter, createWebHistory } from 'vue-router';

// Layouts
import DefaultLayout from '@layouts/Default.vue';			// dashboard
import FullScreenLayout from '@layouts/FullScreen.vue';		// login / auth

// Private views
import Statistics from '@views/private/Statistics.vue';
import Dashboard from '@views/private/Dashboard.vue';
import CustomerDetail from '@views/private/CustomerDetail.vue';
import Stock from '@views/private/Stock.vue';
import Settings from '@views/private/Settings.vue';
import PreNotification from '@views/private/PreNotification.vue';
import PreNotificationProducts from '@views/private/PrenotificationProducts.vue';
import PreNotificationDetail from '@views/private/PreNotificationDetail.vue';
import UserManagement from '@views/private/UserManagement.vue';
import RolesRights from '@views/private/RolesRights.vue';
import RolesRightsDetail from '@views/private/RolesRightsDetail.vue';
import ActivitiesDetail from '@views/private/ActivitiesDetail.vue';
import StockDetail from '@views/private/StockDetail.vue';
import BundleDetail from '@views/private/BundleDetail.vue';
import DeliveryPickUp from '@views/private/DeliveryPickUp.vue';
import DeliveryDetail from '@views/private/DeliveryDetail.vue';
import ItemDetail from '@views/private/ItemDetail.vue';
import UserDetails from '@views/private/UserDetails.vue';
import RepairOverview from '@views/private/RepairOverview.vue';
import RepairDetail from '@views/private/RepairDetail.vue';
import EOLOverview from '@views/private/EOLOverview.vue';
import EOLDetail from '@views/private/EOLDetail.vue';

// Public views
import NotFound from '@views/NotFound.vue';

// Login
import Activate from '@views/public/login/Activate.vue';
import Login from '@views/public/login/Login.vue';
import PasswordForget from '@views/public/login/PasswordForget.vue';
import PasswordForgetSuccess from '@views/public/login/PasswordForgetSuccess.vue';
import PasswordRestore from '@views/public/login/PasswordRestore.vue';
import PasswordRestoreSuccess from '@views/public/login/PasswordRestoreSuccess.vue';
// TwoFactor
import TwoFactor from '@views/public/login/twofactor/TwoFactor.vue';
import TwoFactorQR from '@views/public/login/twofactor/TwoFactorQR.vue';
import TwoFactorSuccess from '@views/public/login/twofactor/TwoFactorSuccess.vue';



/**
 * Add your project routes here
 * https://router.vuejs.org/guide/
 */
const router = createRouter({
	history: createWebHistory(),
	routes: [{
		path: '/',
		component: DefaultLayout,
		children: [{
			path: '',
			component: Statistics,
			name: 'statistics',
			meta: {
				title: (route) => 'Dashboard',
				private: true,
				topbar: false,
				bgGray: true
			}
		}]
	},{
		path: '/crm',
		component: DefaultLayout,
		children: [{
			path: '',
			component: Dashboard,
			name: 'dashboard',
			meta: {
				title: (route) => 'Klanten',
				private: true,
				topbar: true,
				breadcrumb: [
					'CRM'
				],
				button: [
					($route, user) => {
						return {
							text: 'Nieuwe klant', event: 'new-customer', can: 'Klant aanmaken'
						}
					},
					($route, user) => {
						return {
							text: 'Exporteren', event: 'export', can: 'Klant exporteren'
						}
					},
				],
			}
		}]
	},{
		path: '/klant/:id',
		component: DefaultLayout,
		children: [{
			path: '',
			component: CustomerDetail,
			name: 'customerDetail',
			meta: {
				title: (route) => 'Klant detail',
				breadcrumb: [
					'dashboard'
				],
				private: true,
				topbar: false
			}
		}]
	},
	{
		path: '/activiteiten/:id',
		component: DefaultLayout,
		children: [{
			path: '',
			component: ActivitiesDetail,
			name: 'activitiesDetail',
			meta: {
				title: (route) => 'Activiteiten detail',
				breadcrumb: [
					'dashboard'
				],
				private: true,
				topbar: true,
			}
		}]
	},
	{
		path: '/activiteiten/leveringen/:id',
		component: DefaultLayout,
		children: [{
			path: '',
			component: ActivitiesDetail,
			name: 'activitiesRepair',
			meta: {
				title: (route) => 'Activiteiten detail',
				breadcrumb: [
					'dashboard'
				],
				private: true,
				topbar: true,
			}
		}]
	},
	{
		path: '/bundle/:id',
		component: DefaultLayout,
		children: [{
			path: '',
			component: BundleDetail,
			name: 'bundleDetail',
			meta: {
				title: (route) => 'Bundel detail',
				breadcrumb: [
					'dashboard'
				],
				private: true,
				topbar: true,
				button: [
					($route, user) => {
						return {
							text: 'Selectie wordt bundel', event: 'remove-from-bundle', can: 'Bundel wijzigen'
						}
					},
				],
			}
		}]
	},
	{
		path: '/voorraad/:id',
		component: DefaultLayout,
		children: [{
			path: '',
			component: StockDetail,
			name: 'stockDetail',
			meta: {
				title: (route) => 'Artikel detail',
				breadcrumb: [
					'dashboard'
				],
				private: true,
				topbar: true,
				button: [
					($route, user) => {
						return {
							text: 'Exporteren', event: 'export', can: 'Voorraad exporteren'
						}
					},
				],
			}
		}]
	},
	{
		path: '/voorraad',
		component: DefaultLayout,
		children: [{
			path: '',
			component: Stock,
			name: 'stock',
			meta: {
				title: (route) => 'Voorraad',
				private: true,
				topbar: true,
				button: [
					($route, user) => {
						return {
							text: 'Nieuw', event: 'new-stock', can: 'Voorraad aanmaken'
						}
					},
					($route, user) => {
						return {
							text: 'Importeren', event: 'import', can: 'Voorraad importeren'
						}
					},
					($route, user) => {
						return {
							text: 'Exporteren', event: 'export', can: 'Voorraad exporteren'
						}
					},
				],
				extraButtons: [
					($route, user) => {
						return {
							text: 'Voorraad afroepen', event: 'bulk', can: 'Bulkafroep aanmaken'
						}
					},
				],
			}
		}]
	},
	{
		path: '/item/:id',
		component: DefaultLayout,
		children: [{
			path: '',
			component: ItemDetail,
			name: 'itemDetail',
			meta: {
				title: (route) => 'Detail - HP Probook 450 GB',
				private: true,
				topbar: false,
			}
		}]
	},
	{
		path: '/leveringen',
		component: DefaultLayout,
		children: [{
			path: '',
			component: DeliveryPickUp,
			name: 'deliveryPickUp',
			meta: {
				title: (route) => 'Leveringen/ophaal overzicht',
				private: true,
				topbar: true,
				button: [
					($route, user) => {
						return {
							text: 'Exporteren', event: 'exportDelivery', can: 'Levering exporteren'
						}
					},
				],
			}
		}]
	},
	{
		path: '/leveringen/:id',
		component: DefaultLayout,
		children: [{
			path: '',
			component: DeliveryDetail,
			name: 'deliveryDetail',
			meta: {
				title: (route) => 'Levering detail',
				breadcrumb: [
					'leveringen'
				],
				private: true,
				topbar: false,
			}
		}]
	},
	{
		path: '/reparaties',
		component: DefaultLayout,
		children: [{
			path: '',
			component: RepairOverview,
			name: 'repair',
			meta: {
				title: (route) => 'Reparatie overzicht',
				private: true,
				topbar: true,
				button: [
					($route, user) => {
						return {
							text: 'Exporteren', event: 'exportRepair', can: 'Reparaties exporteren'
						}
					},
				],
			}
		}]
	},
	{
		path: '/reparaties/:id',
		component: DefaultLayout,
		children: [{
			path: '',
			component: RepairDetail,
			name: 'repairDetail',
			meta: {
				title: (route) => 'Reparatie overzicht',
				breadcrumb: [
					'Reparatie overzicht'
				],
				private: true,
				topbar: false,
			}
		}]
	},
	{
		path: '/eol',
		component: DefaultLayout,
		children: [{
			path: '',
			component: EOLOverview,
			name: 'eol',
			meta: {
				title: (route) => 'EOL overzicht - Alle assets die binnen 3 maanden EOL zijn',
				private: true,
				topbar: true,
				button: [
					($route, user) => {
						return {
							text: 'Exporteren', event: 'exportEOL', can: 'EOL exporteren'
						}
					},
				],
			}
		}]
	},
	{
		path: '/eol/:id',
		component: DefaultLayout,
		children: [{
			path: '',
			component: EOLDetail,
			name: 'EOLDetail',
			meta: {
				title: (route) => 'EOL overzicht',
				breadcrumb: [
					'EOL overzicht'
				],
				private: true,
				topbar: false,
			}
		}]
	},
	{
		path: '/instellingen',
		component: DefaultLayout,
		children: [{
			path: '',
			component: Settings,
			name: 'settings',
			meta: {
				title: (route) => 'Instellingen',
				private: true,
				topbar: false,
			}
		}]
	},{
		path: '/rollen-en-rechten',
		component: DefaultLayout,
		children: [{
			path: '',
			component: RolesRights,
			name: 'rolesRights',
			meta: {
				title: (route) => 'Rollen en rechten',
				private: true,
				topbar: true,
				button: [
					($route, user) => {
						return {
							text: 'Nieuw', event: 'new-roles-rights', can: 'Rol aanmaken'
						}
					},
				],
			}
		}]
	},{
		path: '/rollen-en-rechten/:id',
		component: DefaultLayout,
		children: [{
			path: '',
			component: RolesRightsDetail,
			name: 'rolesRightsDetail',
			meta: {
				title: (route) => '',
				breadcrumb: [
					'rolesRights'
				],
				private: true,
				topbar: false,
			}
		}]
	},{
		path: '/gebruikersbeheer',
		component: DefaultLayout,
		children: [{
			path: '',
			component: UserManagement,
			name: 'userManagement',
			meta: {
				title: (route) => 'Gebruikersbeheer',
				private: true,
				topbar: true,
				button: [
					($route, user) => {
						return {
							text: 'Exporteren', event: 'export', can:'Gebruikers exporteren'
						}
					},
				],
			}
		}]
	},
	{
		path: '/gebruikers/:id',
		component: DefaultLayout,
		children: [{
			path: '',
			component: UserDetails,
			name: 'userDetails',
			meta: {
				title: (route) => 'Gebruiker',
				breadcrumb: [
					'userManagement'
				],
				private: true,
				topbar: true,
			}
		}]
	},
	{
		path: '/voormeldingen',
		component: DefaultLayout,
		children: [{
			path: '',
			component: PreNotification,
			name: 'PreNotification',
			meta: {
				title: (route) => 'Voormeldingen',
				topbar: true,
				private: true,
				button: [
					($route, user) => {
						return {
							text: 'Nieuwe voormelding', event: 'new-prenotification', can: 'Voormelding aanmaken'
						}
					},
					($route, user) => {
						return {
							text: 'Exporteren', event: 'export', can: 'Voormelding exporteren'
						}
					},
				],
			}
		}]
	},
	{
		path: '/voormeldingen/:id', 
		component: DefaultLayout,
		children: [{
			path: '',
			component: PreNotificationProducts,
			name: 'PreNotificationProducts',
			meta: {
				title: (route) => 'Voormelding',
				topbar: false,
				private: true
			}
		}]
	}, 
	{
		path: '/voormelding/:id',
		component: DefaultLayout,
		children: [{
			path: '',
			component: PreNotificationDetail,
			name: 'preNotificationDetail',
			meta: {
				title: (route) => 'Voormelding',
				topbar: false,
				private: true,
			}
		}]
	},{
		path: '/inloggen',
		component: FullScreenLayout,
		children: [{
			path: '',
			component: Login,
			name: 'login',
			meta: {
				title: (route) => 'Inloggen',
				private: false
			}
		}]
	}, {
		path: '/activeren/:token',
		component: FullScreenLayout,
		children: [{
			path: '',
			component: Activate,
			name: 'activate',
			meta: {
				title: (route) => 'Activeren',
				private: false
			}
		}]
	}, {
		path: '/wachtwoord-vergeten',
		component: FullScreenLayout,
		children: [{
			path: '',
			component: PasswordForget,
			name: 'password-forget',
			meta: {
				title: (route) => 'Wachtwoord vergeten',
				private: false
			}
		}]
	}, {
		path: '/wachtwoord-vergeten/succes',
		component: FullScreenLayout,
		children: [{
			path: '',
			component: PasswordForgetSuccess,
			name: 'password-forget-success',
			meta: {
				title: (route) => 'Wachtwoord reset aangevraagd',
				private: false
			}
		}]
	}, {
		path: '/wachtwoord-vernieuwen/:token',
		component: FullScreenLayout,
		children: [{
			path: '',
			component: PasswordRestore,
			name: 'password-forget-restore',
			meta: {
				title: (route) => 'Wachtwoord vernieuwen',
				private: false
			}
		}]
	}, {
		path: '/wachtwoord-vernieuwen/succes',
		component: FullScreenLayout,
		children: [{
			path: '',
			component: PasswordRestoreSuccess,
			name: 'password-forget-restore-success',
			meta: {
				title: (route) => 'Wachtwoord vernieuwen gelukt',
				private: false
			}
		}]
	}, {
		path: '/tweestapsverificatie',
		component: FullScreenLayout,
		children: [{
			path: '',
			component: TwoFactor,
			name: 'two-factor-authentication',
			meta: {
				title: (route) => 'Tweestapsverificatie',
				private: false
			}
		}]
	}, {
		path: '/tweestapsverificatie/qr',
		component: FullScreenLayout,
		children: [{
			path: '',
			component: TwoFactorQR,
			name: 'two-factor-authentication-qr',
			meta: {
				title: (route) => 'Tweestapsverificatie QR scan',
				private: false
			}
		}]
	}, {
		path: '/tweestapsverificatie/succes',
		component: FullScreenLayout,
		children: [{
			path: '',
			component: TwoFactorSuccess,
			name: 'two-factor-authentication-success',
			meta: {
				title: (route) => 'Tweestapsverificatie gelukt',
				private: false
			}
		}]
	},
	{
		path: "/:catchAll(.*)",
		component: FullScreenLayout,
		children: [{
			path: '',
			component: NotFound,
			meta: {
				title: (route) => 'Niet gevonden'
			}
		}]
	}],

});

export default router;